import React, { useEffect, useState } from "react";
import Container from "../components/container";
import { useTranslation } from 'react-i18next';
import { pdfSlides } from "../data/slidesData";
import { pdfManuals } from "../data/manualData";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
  List,
  ListItem,
} from "@material-tailwind/react";

import PDFImg from "../img/icons/pdfIcon.svg";
import { FilmIcon, BookOpenIcon, PresentationChartBarIcon } from "@heroicons/react/24/outline";
import Videos from "./videos";

function Manual() {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  // Gestion des onglets principaux via l'URL
  const getDefaultTab = () => {
    const hash = window.location.hash.replace("#", "");
    return ["vids", "slides", "manual"].includes(hash) ? hash : "vids";
  };

  const [activeTab, setActiveTab] = useState(getDefaultTab);
  const [isInstitutional, setIsInstitutional] = useState(false);

  useEffect(() => {
    const handleHashChange = () => {
      setActiveTab(getDefaultTab());
    };
    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  const changeTab = (tab) => {
    window.location.hash = tab;
    setActiveTab(tab);
  };

  // Fonction pour filtrer les PDF selon le type d'utilisateur
  const filterPdfs = (pdfs) => {
    return pdfs.filter(pdf => {
      if (!pdf.userType) return true; // Si pas de userType défini, on montre à tous
      if (isInstitutional) {
        return pdf.userType === 'instEnterprise' || pdf.userType === 'all';
      } else {
        return pdf.userType === 'non-instEnterprise' || pdf.userType === 'all';
      }
    });
  };

  return (
    <>
      <Tabs value={activeTab}>
        <TabsHeader className="my-10 mx-10 flex flex-col md:flex-row">
          <Tab value="vids" onClick={() => changeTab("vids")}>
            <div className="flex gap-4 text-blue-800">
              <FilmIcon className="w-6 h-6" />
              <div>{t('manual-videos')}</div>
            </div>
          </Tab>
          <Tab value="slides" onClick={() => changeTab("slides")}>
            <div className="flex gap-4 text-blue-800">
              <PresentationChartBarIcon className="w-6 h-6" />
              <div>{t('manual-slides')}</div>
            </div>
          </Tab>
          <Tab value="manual" onClick={() => changeTab("manual")}>
            <div className="flex gap-4 text-blue-800">
              <BookOpenIcon className="w-6 h-6" />
              <div>{t('manual-manual')}</div>
            </div>
          </Tab>
        </TabsHeader>

        <TabsBody>
          <TabPanel key="slides" value="slides">
            <Container className="flex flex-col gap-6">
              <div className="font-bold text-3xl text-left text-blue-900 dark:text-yellow-800">
                {t('manual-slides-title')}
              </div>
              
              <div className="text-gray-700 dark:text-white">
                {t('manual-slides-word')}
              </div>

              <div className="flex gap-4 mb-6">
                <button
                  onClick={() => setIsInstitutional(false)}
                  className={`px-4 py-2 rounded-lg ${!isInstitutional ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}>
                  {t('button-citizen-and-enterprise')}
                </button>
                <button
                  onClick={() => setIsInstitutional(true)}
                  className={`px-4 py-2 rounded-lg ${isInstitutional ? 'bg-yellow-700 text-blue-900' : 'bg-gray-100 text-gray-700'}`}>
                  {t('button-institutional-enterprise')}
                </button>
              </div>

              <List>
                {filterPdfs(pdfSlides).map((pdfFile, index) => (
                  <a key={index} href={pdfFile.url[currentLang]} download>
                    <ListItem className="dark:hover:bg-blue-1000">
                      <div className="flex flex-row gap-6 items-center dark:text-white">
                        <div className="w-10 h-10 flex-shrink-0">
                          <img src={PDFImg} alt="PDF Icon" className="w-full h-full" />
                        </div>
                        <div className="flex flex-col gap-2">
                          <div className="font-bold text-blue-700 dark:text-white">
                            Module {pdfFile.numb} : {pdfFile.name[currentLang]}
                          </div>
                        </div>
                      </div>
                    </ListItem>
                  </a>
                ))}
              </List>
            </Container>
          </TabPanel>

          <TabPanel key="manual" value="manual">
            <Container className="flex flex-col gap-6">
              <div className="font-bold text-3xl text-left text-blue-900 dark:text-yellow-800">
                {t('manual-manual-title')}
              </div>
              <div className="text-gray-700 dark:text-white">
                {t('manual-manual-word')}
              </div>
              <List>
                {filterPdfs(pdfManuals).map((pdfFile, index) => (
                  <a key={index} href={pdfFile.url[currentLang]} download>
                    <ListItem className="dark:hover:bg-blue-1000">
                      <div className="flex flex-row gap-6 items-center dark:text-white">
                        <div className="w-10 h-10 flex-shrink-0">
                          <img src={PDFImg} alt="PDF Icon" className="w-full h-full" />
                        </div>
                        <div className="flex flex-col gap-2">
                          <div className="font-bold text-blue-700 dark:text-white">
                            {pdfFile.name[currentLang]}
                          </div>
                        </div>
                      </div>
                    </ListItem>
                  </a>
                ))}
              </List>
            </Container>
          </TabPanel>

          <TabPanel key="vids" value="vids">
            <Videos isTrainingMode={true} />
          </TabPanel>
        </TabsBody>
      </Tabs>
    </>
  );
}

export default Manual;